<div class="form-group">
    <div class="col-md-3">
        <select class="form-control" id="reporte" ngModel name="reporte" #r (change)="cambiarReporte(r.value)">
            <option value=" ">Seleccione el reporte</option>
            <option *ngFor="let reporte of reportes " [value]="reporte.ruta ">{{reporte.nombre}} </option>
        </select>
    </div>
</div>
<iframe class="rowIframe " id="iframeReporteador" frameborder="0" type="text/html ">
</iframe>